module.exports = __webpack_public_path__ + "media/coins.c77058a8.mp3";